import { useEffect, useState } from "react";
import { Link as RouterLink, Navigate } from "react-router-dom";
import { Box, Chip, Container, Paper, Table, TableBody, TableCell, TableHead, TableRow, Typography } from "@mui/material";
import { OrderController } from "../controllers/order";
import { useAuth } from "../context/AuthContext";

export default function Orders() {
  const { user, loading } = useAuth();
  const [rows, setRows] = useState([]);
  const [busy, setBusy] = useState(true);

  useEffect(() => {
    if (!user) return;
    OrderController.list()
      .then((r) => setRows(r?.items || r || []))
      .catch(() => setRows([]))
      .finally(() => setBusy(false));
  }, [user]);

  if (loading) return null;
  if (!user) return <Navigate to="/login" replace />;

  return (
    <Container maxWidth="lg" sx={{ py: 6 }}>
      <Typography variant="h2" sx={{ fontSize: "1.8rem", mb: 3 }}>Orders</Typography>
      <Paper>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Order #</TableCell>
              <TableCell>Date</TableCell>
              <TableCell>Status</TableCell>
              <TableCell align="right">Total</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {busy ? (
              <TableRow><TableCell colSpan={4}>Loading…</TableCell></TableRow>
            ) : rows.length === 0 ? (
              <TableRow><TableCell colSpan={4}><Box sx={{ p: 2 }}>No orders yet.</Box></TableCell></TableRow>
            ) : rows.map((o) => (
              <TableRow key={o.id} hover component={RouterLink} to={`/orders/${o.id}`}
                sx={{ textDecoration: "none", cursor: "pointer" }}>
                <TableCell>{o.number || o.id}</TableCell>
                <TableCell>{o.date || "—"}</TableCell>
                <TableCell><Chip size="small" label={o.status || "pending"} /></TableCell>
                <TableCell align="right">{o.total ? `$${Number(o.total).toFixed(2)}` : "—"}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Paper>
    </Container>
  );
}
